"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

const Header = ({
  level,
  color,
  primary,
  secondary,
  dark,
  size,
  children,
  className,
  id
}) => {
  const Tag = `h${level}`;
  return (0, _jsxRuntime.jsx)(Tag, {
    css: theme => [_styles.styles.default(theme, color, size), level === 1 && _styles.styles.h1, level === 2 && _styles.styles.h2, level === 3 && _styles.styles.h3, level === 4 && _styles.styles.h4, level === 5 && _styles.styles.h5, primary && _styles.styles.setColor(theme.primary), secondary && _styles.styles.setColor(theme.secondary), dark && _styles.styles.setColor(theme.secondaryDarkText)],
    id: id,
    className: className,
    children: children
  });
};
var _default = exports.default = Header;